const Dashboard =()=>import(/* webpackChunkName: "js/member" */'@/views/member/Dashboard');
const Results =()=>import(/* webpackChunkName: "js/member" */'@/views/member/Results');
const VoteNominate =()=>import(/* webpackChunkName: "js/member" */'@/views/member/VoteNominate');
const MemberApplications =()=>import(/* webpackChunkName: "js/member" */'@/views/member/Applications');
const CandidateDashboard =()=>import(/* webpackChunkName: "js/member" */'@/views/member/CandidateDashboard');
const MemberDocuments =()=>import(/* webpackChunkName: "js/member" */'@/views/member/MemberDocuments');
export default [
    {
        path:"/members",
        component:Dashboard,
        name:"MemberHome",
    },
    {
        path:"/members/nominate",
        component:VoteNominate,
        name:"MemberVoteNominate",
    },
    {
        path:"/members/results",
        component:Results,
        name:"MemberVoteResults",
    },
    {
        path:"/members/applications",
        component:MemberApplications,
        name:"MemberApplications",
    },
    {
        path:"/members/candidates",
        component:CandidateDashboard,
        name:"CandidateDashboard",
    },
    {
        path:"/members/candidate-documents/:type",
        component:MemberDocuments,
        name:"MemberDocuments",
        props:true
    },
]
